<template>
  <div>

    <v-app v-if="mobConfig">
      <v-navigation-drawer app right v-model="drawer" temporary>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              <span v-html="title"></span>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span v-html="mobConfig.companyName"></span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item v-if="mobConfig.enabledSchool" link to="/course">
            <v-list-item-icon>
              <v-icon>{{ mobSchoolIcon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title><span v-html="schoolHeader"></span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="mobConfig.enabledRent" link to="/rent">
            <v-list-item-icon>
              <v-icon>{{ mobRentIcon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title><span v-html="rentHeader"></span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/cart">
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t("Košík") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item v-if="user" link to="/order-history">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Účet a objednávky</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <template v-for="sc in staticContentList">
            <v-list-item
              v-if="!sc.isExternal"
              :key="sc.id"
              link
              :to="'/static-content/' + sc.id + '/' + sc.linkUrl"
            >
              <v-list-item-icon>
                <v-icon>{{ sc.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  <span v-html="translateFromPayload(sc.title)"></span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="sc.isExternal"
              :key="sc.id"
              link
              :href="sc.linkUrl"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>{{ sc.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  <span v-html="translateFromPayload(sc.title)"></span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-divider></v-divider>

        <div v-if="user != null">
          <amplify-sign-out class="signout"></amplify-sign-out>
        </div>

        <v-spacer></v-spacer>

        <template v-slot:append>
          <div class="pa-2">
            <div class="text-caption text-center">
              {{ $t("Vytvořeno na platformě") }} :
            </div>
            <v-btn block text small @click="navigateToMatesWeb">
              www.is-mates.cz
            </v-btn>
            <p class="app-version">
              {{ appVersion }} / {{ mobConfig.mobVersion }}
            </p>
          </div>
        </template>
      </v-navigation-drawer>

      <v-app-bar app>
        <router-link to="/">
          <v-img
            :alt="mobConfig.title"
            class="shrink mr-2 d-none d-sm-block"
            contain
            :src="mobConfig.webLogoUrl"
            transition="scale-transition"
            height="43"
            width="200"
          />

          <v-img
            :alt="mobConfig.title"
            class="shrink mr-2 d-sm-none"
            contain
            :src="mobConfig.webLogoSmallUrl"
            transition="scale-transition"
            height="40"
            width="40"
          />
        </router-link>

        <v-tabs
          v-model="tabsModel"
          v-if="
            $vuetify.breakpoint.mdAndUp &&
            mobConfig.enabledSchool &&
            mobConfig.enabledRent
          "
          align-with-title
        >
          <v-tab @change="navigateToSchool"><span v-html="schoolHeader"></span></v-tab>
          <v-tab @change="navigateToRent"><span v-html="rentHeader"></span></v-tab>
        </v-tabs>
        <v-toolbar-title v-else class="d-none d-md-block">
          <span v-html="title"></span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- <template v-if="user == null">
          <v-btn rounded @click="loginRequest">
            <v-icon> mdi-account </v-icon>
          </v-btn>
        </template>

        <template v-if="user != null">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                bordered
                color="success"
                overlap
                :content="badgeMonogram"
                class="mr-4"
              >
                <v-btn rounded to="/order-history" v-bind="attrs" v-on="on">
                  <v-icon> mdi-account </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ userTooltip }}</span>
          </v-tooltip>
        </template> -->

        <locale-select></locale-select>

        <v-btn rounded class="ml-2 mr-5" to="/cart">
          <v-icon left>mdi-cart</v-icon>
          <span class="d-none d-sm-inline"> {{ $t("Košík") }}</span>
          <template v-if="orderr">
            &nbsp;|
            <countdown
              :end-time="orderrExpirationTime"
              v-on:finish="orderrExpirationHandler"
            >
              <span slot="process" slot-scope="cartSlotScope">
                &nbsp;{{
                  `${cartSlotScope.timeObj.m}:${cartSlotScope.timeObj.s}`
                }}</span
              >
              <template slot="finish">
                <span slot="finish">&nbsp;{{ $t("Čas vypršel") }}</span>
              </template>
            </countdown>
          </template>
        </v-btn>

        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-main>
        <v-container fluid class="pa-0 main-container" style="height: 100%">
          <router-view @loginRequest="loginRequest" />
        </v-container>

        <!-- notifikace - expirace objednvky -->
        <v-row justify="center">
          <v-dialog v-model="expirationSnackbar" persistent max-width="550">
            <v-card>
              <v-card-title class="headline">
                <v-icon color="green"> mdi-checkbox-marked </v-icon>
                {{ $t("vyprselCasProDokonceni") }}
              </v-card-title>
              <v-card-text>{{ $t("nesloDeleBlokovat") }} </v-card-text>
              <v-card-actions>
                <v-btn @click="resetExpiredOrerr()" text>
                  {{ $t("Vytvořit novou objednávku") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-main>
    </v-app>
  </div>
</template>

<script>
// import { Auth } from "aws-amplify";
// import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import moment from "moment";
import LocaleSelect from "@/components/LocaleSelect";
import LocaleUtil from "@/libs/LocaleUtil";
import { setOptions, bootstrap } from 'vue-gtag';

export default {
  name: "app",

  components: {
    LocaleSelect,
  },

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "",
    // all titles will be injected into this template
    titleTemplate: "%s | Online rezervace",
  },

  data() {
    return {
      tabsModel: null,
      drawer: false,
      loginWindowOpened: false,
      signedIn: false,
      authState: undefined,
      unsubscribeAuth: undefined,
      authErrorMessage: undefined, // nepouziva se, odpojeno
      formFields: [
        {
          type: "email",
          label: "E-mail",
          placeholder: "Zadejte váš e-mail",
          inputProps: { required: true, autocomplete: "username" },
        },
        {
          type: "password",
          label: "Heslo",
          placeholder: "Zadejte vaše heslo",
          inputProps: { required: true, autocomplete: "new-password" },
        },
        {
          type: "name",
          label: "Jméno",
          placeholder: "Křestní jméno",
          inputProps: { required: true },
        },
        {
          type: "family_name",
          label: "Příjmení",
          placeholder: "Příjmení",
          inputProps: { required: true },
        },
      ],
      expirationAlertSnackbar: false,
      expirationSnackbar: false,
      snackbarTimeout: 5000,
    };
  },

  watch: {
    $route(to) {
      console.log("zmena routy ")
      console.log(to.path);
      let path = to.path;
      if(to != null) {
        if (path.includes("/course") > 0) {
        this.tabsModel = 0;
      } else if (path.includes("/rent") > 0) {
        this.tabsModel = 1;
      }
      }
      
    },
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    mobRentIcon() {
      return this.$store.state.mobRentIcon;
    },

    mobSchoolIcon() {
      return this.$store.state.mobSchoolIcon;
    },

    mobConfig() {
      return this.$store.state.mobConfig;
    },

    title() {
      return LocaleUtil.translateFromPayload(
        this.mobConfig.title,
        this.$i18n.locale
      );
    },

    schoolHeader() {
      return LocaleUtil.translateFromPayload(
        this.mobConfig.schoolHeader,
        this.$i18n.locale
      );
    },

    rentHeader() {
      return LocaleUtil.translateFromPayload(
        this.mobConfig.rentHeader,
        this.$i18n.locale
      );
    },

    appVersion() {
      return this.$store.state.appVersion;
    },

    badgeMonogram() {
      if (this.user == null) {
        return "";
      }

      let monogram = "";
      if (
        this.user.attributes.name != undefined &&
        this.user.attributes.family_name != undefined
      ) {
        monogram =
          this.user.attributes.name.slice(0, 1) +
          "" +
          this.user.attributes.family_name.slice(0, 1);
      } else {
        monogram = this.user.attributes.email.slice(0, 2);
      }

      return monogram.toUpperCase();
    },

    userTooltip() {
      if (this.user == null) {
        return "Přihlásit se";
      }

      let tooltip = "";
      if (
        this.user.attributes.name != undefined &&
        this.user.attributes.family_name != undefined
      ) {
        tooltip = this.user.attributes.name;
        tooltip += " ";
        tooltip += this.user.attributes.family_name;
        tooltip += " - ";
        tooltip += this.user.attributes.email;
      } else {
        tooltip = this.user.attributes.email;
      }

      return tooltip;
    },

    orderrExpirationTime() {
      return moment(this.$store.state.expireAt).toDate();
    },

    orderrExpirationAlertTime() {
      return moment(this.$store.state.expireAt).subtract(5, "minutes").toDate();
    },

    orderr() {
      return this.$store.state.currentOrderr;
    },

    staticContentList() {
      return this.$store.state.staticContentList;
    },
  },

  methods: {

    enableGtag() {
      setOptions({
        config: { id: 'G-L7EE8EML1V' }
      })

      bootstrap();
    },

    translateFromPayload(payload) {
      return LocaleUtil.translateFromPayload(payload, this.$i18n.locale);
    },

    loginRequest: async function () {
      console.log("loginRequest");
      if (this.user == null) {
        console.log("je null, musi se prihlasit");
        this.loginWindowOpened = true;
      } else {
        console.log("uz je prihlasen");
        this.loginWindowOpened = false;
      }
    },

    closeLoginDialog: function () {
      this.loginWindowOpened = false;
      this.authErrorMessage = undefined;
    },

    navigateToMatesWeb: function () {
      window.location.href = "http://www.ismates.cz";
    },

    async init() {
      console.log("app.vue -- init start");

      await this.$store.dispatch("loadMobConfig");
      this.$store.dispatch("loadLocations");
      this.$store.dispatch("loadPointSells");
      this.$store.dispatch("loadPointMeetings");
      this.$store.dispatch("loadStaticContentList");
      this.$store.dispatch("loadRentProductRequirements");

      let languages = ["cs", "en", "sk", "de", "pl", "hu"];
      if(this.$route.query.lang != undefined
          && this.$route.query.lang != null
          && languages.includes(this.$route.query.lang)
      ) {
        this.$i18n.locale = this.$route.query.lang;
      }
      

      // jestlize je stale null, pokus o nacteni z cookies
      if (this.orderr == null) {
        console.log("Objednavka je NULL");
        let id = this.$cookies.get("orderrId");
        if (id != undefined && id != null) {
          console.log("Nalezen cookie s orderrId:" + id);
          this.$store.dispatch("getOrderr", id);
          console.log("Nacteno z cookie");
        }
      }

      console.log("app.vue -- init done");
    },

    orderrExpirationHandler() {
      console.log("orderrExpirationHandler");
      this.expirationAlertSnackbar = false;
      this.expirationSnackbar = true;

      this.$store.dispatch("updateCurrentOrderrExpired", true);
    },

    async resetExpiredOrerr() {
      // expirace aktualni objednavky - zaslat update na backend

      // reset lokalnich promennych
      await this.$store.dispatch("expireOrderr");

      // schovani modalniho okna
      this.expirationSnackbar = false;

      // presmerovani
      this.navigateToHome();
    },

    navigateToHome() {
      if (this.mobConfig.enabledSchool && !this.mobConfig.enabledRent) {
        this.$router.push({ name: "course", query: {lang: this.$i18n.locale} });
      } else if (!this.mobConfig.enabledSchool && this.mobConfig.enabledRent) {
        this.$router.push({ name: "rent", query: {lang: this.$i18n.locale} });
      } else if (this.mobConfig.enabledSchool && this.mobConfig.enabledRent) {
        this.$router.push({ name: "rent", query: {lang: this.$i18n.locale} });
      } else {
        console.error("Chyba - neni definovana ani sekce pujcvna, ani skola.");
      }
    },

    navigateToSchool() {
      this.$router.push({ name: "course" , query: {lang: this.$i18n.locale}});
    },

    navigateToRent() {
      this.$router.push({ name: "rent" , query: {lang: this.$i18n.locale}});
    },
  },

  async mounted() {
    console.log("mounted -- App.vue");
    this.$i18n.locale = this.$store.state.locales[0];
    this.$vuetify.lang.current = this.$store.state.locales[0];
    this.init();
    this.enableGtag();
  },

  async beforeCreate() {
    // try {
    //   let user = await Auth.currentAuthenticatedUser();
    //   this.$store.dispatch("login", user);
    //   console.log("-- user prihlasen");
    //   this.closeLoginDialog();
    // } catch (err) {
    //   this.$store.dispatch("logout");
    //   console.log("-- user odhlasen");
    // }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  created() {
    // console.log("created");
    // this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
    //   this.authState = authState;
    //   this.$store.dispatch("login", authData);
    //   console.log("authState: ", authState);
    //   if (authState === "signedin") {
    //     this.closeLoginDialog();
    //   }

    //   if (authState === "signedout") {
    //     this.$router.push({
    //       name: "home",
    //     });
    //   }
    // });
    // console.log("created - done");
    //Hub.listen(UI_AUTH_CHANNEL, this.handleToastErrors);
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.signout {
  background-color: #ededed;
  margin: 0;
  padding: 11px 0px 1px;
}
div.auth-wrapper {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  overflow: auto;
}

amplify-authenticator div.error-msg {
  border: solid 1px #dc2b1f;
  background-color: #feb4b4;
  color: #000;
  padding: 1rem;
}

amplify-authenticator div.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

amplify-authenticator::shadow amplify-toast {
  position: fixed;
  top: 40%;
  left: 10%;
  right: 10%;
  z-index: 200;
}

.app-version {
  text-align: center;
  margin: 1rem;
  color: #888;
}

/*
.main-container {
  background-color: #ccc;
}
*/

.v-card__title .text-h4,
.v-card__subtitle .text-h5 {
  word-break: normal;
}
</style>
